export enum FileType
{
    Undefined = 0,

    Image = 100,
    PngImage = 105,
    JpgImage = 110,

    Pdf = 200
}